import * as React from 'react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType
} from 'react-router-dom';
import * as Sentry from '@sentry/react';
import * as config from './config';

type User = {
  id: string;
  email: string;
  name: string;

  agencyId?: string;
  agencyName?: string;

  accountId?: string;
  accountName?: string;
};

export const setUser = (user: User | null) => {
  Sentry.setUser(user);
};

Sentry.init({
  dsn: config.getSentryDSN(),
  integrations: [
    Sentry.browserProfilingIntegration(),
    Sentry.browserSessionIntegration(),
    Sentry.browserTracingIntegration(),
    Sentry.captureConsoleIntegration({
      levels: ['error']
    }),
    Sentry.extraErrorDataIntegration(),
    Sentry.httpClientIntegration(),
    Sentry.launchDarklyIntegration(),
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect: React.useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes
    }),
    Sentry.replayIntegration({
      networkDetailAllowUrls: [window.location.origin, config.getApiBaseUrl()],
      networkCaptureBodies: true,
      networkRequestHeaders: ['X-Oyster-Application-Namespace'],
      maskAllText: false,
      blockAllMedia: false
    })
  ],

  enabled: config.getEnvironment() === 'production',

  environment: config.getEnvironment(),
  release: config.getServiceVersion(),

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  tracesSampleRate: 1.0,

  // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [config.getApiBaseUrl()],

  // Capture Replay for 100% of all sessions,
  // plus for 100% of sessions with an error
  replaysSessionSampleRate: 1.0,
  replaysOnErrorSampleRate: 1.0
});
